"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBOneClickPositive = function SvgBOneClickPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M45.286 87.454a2.108 2.108 0 01-.8-.155 45.335 45.335 0 1159.082-24.424 2.11 2.11 0 01-3.892-1.63 41.135 41.135 0 10-53.589 22.156 2.107 2.107 0 01-.8 4.053z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M48.567 66.676c-.43.001-.85-.131-1.202-.38-9.879-6.872-13.564-19.743-8.82-30.803 4.743-11.06 16.609-17.261 28.397-14.84 11.789 2.42 20.25 12.796 20.252 24.83a2.107 2.107 0 11-4.215 0A21.143 21.143 0 1049.775 62.84a2.107 2.107 0 01-1.208 3.836zM116.738 70.504a2.108 2.108 0 01-1.945-2.93 57.038 57.038 0 004.088-15.678 59.75 59.75 0 00.365-6.547 57.235 57.235 0 00-9.666-32.003A2.112 2.112 0 11113.093 11a61.5 61.5 0 0110.41 34.328c0 2.347-.132 4.692-.394 7.025a61.484 61.484 0 01-4.39 16.858 2.108 2.108 0 01-1.98 1.293zM8.345 74.03c-.8.002-1.532-.45-1.89-1.166a61.927 61.927 0 01-2.943-48.047 2.108 2.108 0 013.976 1.405 57.705 57.705 0 002.754 44.766 2.107 2.107 0 01-.942 2.81c-.296.15-.623.23-.955.232z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M98.538 143.916c-.222 0-.443-.035-.653-.106a2.107 2.107 0 01-1.23-1.046l-12.264-24.298-17.828 14.9a2.107 2.107 0 01-3.456-1.617V48.763a2.107 2.107 0 114.215 0v78.477l16.402-13.705a2.107 2.107 0 013.23.703l12.511 24.768 11.443-5.83a2.107 2.107 0 111.918 3.75l-13.347 6.8a2.18 2.18 0 01-.94.19z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M98.341 111.084a2.114 2.114 0 11-.33-4.215l20.371-3.217-45.209-43.488a2.109 2.109 0 112.93-3.035l48.229 46.46a2.107 2.107 0 01-1.131 3.596l-24.536 3.87c-.107.02-.215.03-.324.029z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M107.108 128.652a2.107 2.107 0 01-1.883-1.152l-8.703-17.217a2.108 2.108 0 013.765-1.897l8.703 17.21a2.107 2.107 0 01-.934 2.81 2.065 2.065 0 01-.948.246z",
    fill: "#285"
  })));
};

var _default = SvgBOneClickPositive;
exports["default"] = _default;